<template>
  <div v-if="appliedDiscounts.length > 0" class="col-12 discounts-container">
    <div
      v-for="(config, type) in appliedDiscountsConfigsFiltered"
      :key="type"
      class="table-discounts"
    >
      <app-title :label="config.label" />

      <table class="discount-detail">
        <thead>
          <tr>
            <th v-for="column in config.columns" :key="column.field">
              {{ column.label }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="discount in getAppliedDiscountsByType(type)"
            :key="discount.clientId + discount.type"
          >
            <td v-for="column in config.columns" :key="column.field">
              {{ getAppliedDiscountValue(discount, column.field) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { useAppliedDiscounts } from '@shared/composables/useAppliedDiscounts'
import { appTitle } from 'tb-design_system-web'
import { ref } from 'vue'

export default {
  name: 'AppliedDiscountsTable',

  components: { appTitle },

  props: {
    appliedDiscounts: {
      type: Array,
      required: true
    }
  },

  setup(props) {
    const discountsRef = ref(props.appliedDiscounts)

    const { appliedDiscountsConfigsFiltered, getAppliedDiscountsByType, getAppliedDiscountValue } =
      useAppliedDiscounts(discountsRef)

    return {
      discountsRef,
      appliedDiscountsConfigsFiltered,
      getAppliedDiscountsByType,
      getAppliedDiscountValue
    }
  }
}
</script>
